import { on } from '../events/index.js';
import { ReactiveValue } from './reactive-value.js';

const parenthesis_regex = /\(.+\)/;

/*                                                                             */
//
/*                           */
//
/*                                                                                            */
/*                                                      */
//
/*                                                                         */
/*                            */
//
/*                                              */
const non_parenthesized_keywords = new Set(['all', 'print', 'screen', 'and', 'or', 'not', 'only']);

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export class MediaQuery extends ReactiveValue {
	/**
 *
 *
 */
	constructor(query, fallback) {
		let final_query =
			parenthesis_regex.test(query) ||
			/*                                                                                                          */
			query.split(/[\s,]+/).some((keyword) => non_parenthesized_keywords.has(keyword.trim()))
				? query
				: `(${query})`;
		const q = window.matchMedia(final_query);
		super(
			() => q.matches,
			(update) => on(q, 'change', update)
		);
	}
}
